/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnrollmentStatusRow } from './EnrollmentStatusRow';
import {
    EnrollmentStatusRowFromJSON,
    EnrollmentStatusRowFromJSONTyped,
    EnrollmentStatusRowToJSON,
    EnrollmentStatusRowToJSONTyped,
} from './EnrollmentStatusRow';

/**
 * 
 * @export
 * @interface EnrollmentStatusBreakdownWidgetData
 */
export interface EnrollmentStatusBreakdownWidgetData {
    /**
     * 
     * @type {Array<EnrollmentStatusRow>}
     * @memberof EnrollmentStatusBreakdownWidgetData
     */
    items: Array<EnrollmentStatusRow>;
}

/**
 * Check if a given object implements the EnrollmentStatusBreakdownWidgetData interface.
 */
export function instanceOfEnrollmentStatusBreakdownWidgetData(value: object): value is EnrollmentStatusBreakdownWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function EnrollmentStatusBreakdownWidgetDataFromJSON(json: any): EnrollmentStatusBreakdownWidgetData {
    return EnrollmentStatusBreakdownWidgetDataFromJSONTyped(json, false);
}

export function EnrollmentStatusBreakdownWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentStatusBreakdownWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(EnrollmentStatusRowFromJSON)),
    };
}

export function EnrollmentStatusBreakdownWidgetDataToJSON(json: any): EnrollmentStatusBreakdownWidgetData {
    return EnrollmentStatusBreakdownWidgetDataToJSONTyped(json, false);
}

export function EnrollmentStatusBreakdownWidgetDataToJSONTyped(value?: EnrollmentStatusBreakdownWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(EnrollmentStatusRowToJSON)),
    };
}

